// extracted by mini-css-extract-plugin
module.exports = {"text_area":"index--text_area--2UYNX","text_area--empty":"index--text_area--empty--3EPxi","text_area--invalid":"index--text_area--invalid--1btLC"};